import { RestClient } from '@/api/rest-client'
import { TypeformResponse } from '@/api/model/typeform/typeform-response'

export class TypeformResponseClient extends RestClient<TypeformResponse> {
    collectionName = 'service/typeform/responses'
    parseData = TypeformResponse.fromData

    async get(id: string, fresh: boolean = false): Promise<TypeformResponse> {
        try {
            if (!fresh && this.cache.has(id)) {
                return this.cache.get(id)
            }

            const response = await this.client.get(`${this.basePath}/${this.collectionName}/${id}`, {
                headers: {
                    Accept: 'application/json',
                },
            })
            const data = this.parseData(response.data) as TypeformResponse

            this.cache.set(id, data)
            return this.cache.get(id)

        } catch (error) {
            this.handleError(error)
        }
    }
}
